import { gql } from '@apollo/client'

import { USER_FRAGMENT } from '../fragments'

// TODO: find a way to avoid having 'status' parameter
export const FORGOT_PASSWORD_CUSTOMER = gql`
  mutation ForgotPasswordCustomer($email: String!) {
    forgotPasswordCustomer(input: { email: $email }) {
      success
    }
  }
`

export const SIGN_CUSTOMER = gql`
  mutation SignCustomer($payload: CustomerSignInput!) {
    signCustomer(input: { payload: $payload }) {
      user {
        ...User
      }
    }
  }
  ${USER_FRAGMENT}
`

export const SIGN_IN_CUSTOMER = gql`
  mutation SignInCustomer($email: String!, $password: String!) {
    signInCustomer(input: { email: $email, password: $password }) {
      user {
        ...User
      }
    }
  }
  ${USER_FRAGMENT}
`

export const LOGOUT_CUSTOMER = gql`
  mutation LogoutCustomer {
    logoutCustomer {
      __typename
    }
  }
`
